<ng-container [matColumnDef]="columnKeyName">
    <mat-header-cell
        *matHeaderCellDef
        style="flex: 0.1"
    >
        <mat-checkbox
            (change)="$event ? selection.masterToggle() : null"
            [aria-label]="selection.getCheckboxLabel()"
            [checked]="selection.isAllSelected()"
            [disabled]="!entityBrowser.getItemsCount()"
            [indeterminate]="selection.hasValue() && !selection.isAllSelected()"
            class="checkbox-column"
            color="primary"
        ></mat-checkbox>
    </mat-header-cell>
    <mat-cell
        *matCellDef="let report"
        style="flex: 0.1"
    >
        <mat-checkbox
            (change)="selection.toggleItem(report, $event.checked)"
            (click)="$event.stopPropagation()"
            [aria-label]="selection.getCheckboxLabel(report)"
            [checked]="selection.isSelectedItem(report)"
            class="checkbox-column"
            color="primary"
        >
        </mat-checkbox>
    </mat-cell>
</ng-container>
